/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import {Button, Dropdown, Menu, Icon} from 'antd';

import './tableBottomActions.less';

const TableBottomActions = ({
  selects, // 选中多少项
  className = '',
  showButtons = 3, // 默认展示几个按钮
  contents = [], // 显示按钮的文案及actions的回调
  showTotalRender = '',
  isMore = true, // 是否显示更多按钮
  ...otherProps
}) => {
  selects = Number(selects) || Number(selects) === 0 ? Number(selects) : null;
  const buttons = isMore
    ? contents.filter((item, idx) => idx < showButtons - 1)
    : contents; // 显示在按钮中
  const more = isMore
    ? contents.filter((item, idx) => idx >= showButtons - 1)
    : contents; // 显示在更多的选项中

  const menu = (
    <Menu>
      {more && Array.isArray(more)
        ? more.map(item => (
            <Menu.Item
              onClick={() => {
                item.action();
              }}>
              {item.name}
            </Menu.Item>
          ))
        : null}
    </Menu>
  );

  return (
    <div
      className={`table-bottom-actions${className ? ` ${className}` : ''}`}
      {...otherProps}>
      <div className="bottom-actions">
        {buttons && Array.isArray(buttons)
          ? buttons.map((item, idx) => (
              <Button
                type={idx === 0 ? 'primary' : ''}
                disabled={selects === 0 && !item.is_no_disabled}
                onClick={() => {
                  item.action();
                }}>
                {item.name}
              </Button>
            ))
          : null}
        {isMore ? (
          <Dropdown overlay={menu} disabled={selects === 0}>
            <Button style={{marginLeft: 8}}>
              <span>更多</span>
              <Icon type="down" />
            </Button>
          </Dropdown>
        ) : null}

        {selects || selects === 0 ? `已选中${selects}项` : null}
      </div>
      <div className="total">{showTotalRender}</div>
    </div>
  );
};

export default TableBottomActions;
